import axios from "axios";
import AuthService from "../auth/msal2-authService";
// import { clientId, tenantId, apiScope } from "./config";
// import { clientId } from "./config";

// let count401 = 0;

axios.create();

axios.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("msal.pkce.access.token");
  // const accessToken =
  //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IjVPZjlQNUY5Z0NDd0NtRjJCT0hIeEREUS1EayJ9.eyJhdWQiOiJmYjEzZTdiYS01ZjAxLTQ1MjktYTZiZS1kOThjNTM3OWZkMTgiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vZDM5YjMwMTgtNjg4Zi00ZDBkLTlmY2UtOGMzY2IxMTY5YzIxL3YyLjAiLCJpYXQiOjE2MDk5OTY3NTYsIm5iZiI6MTYwOTk5Njc1NiwiZXhwIjoxNjEwMDAwNjU2LCJhaW8iOiJBVlFBcS84U0FBQUFrdmJwZFVzbGdVU0xRT1FBRmZreFRvU2FIeVp3cmMxdCsxRUVmQzh0YkdZK2xIY3I0NHhzbjl5VU1ibEhrSExKZ0pUV25QZWxLTjBydEh1U1pGemJLZTB5bmp6NnREN3RSSVlXckg4YVdkMD0iLCJhenAiOiI2YmViZDZkNC1lNjk1LTQ4YTMtYjc1NC1iMDMxOTc1NGYwMDMiLCJhenBhY3IiOiIwIiwibmFtZSI6Ik5hdHRhcGF0IFdvbmd3YXJhbmdrdWwiLCJvaWQiOiIwMTUzN2NlYy05MzNlLTRiODQtOTRkZS1jYzRkNzhkMGMzZTkiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJuYXR0YXBhdC53b0BndWxmLmNvLnRoIiwicmgiOiIwLkFTc0FHRENiMDQ5b0RVMmZ6b3c4c1JhY0lkVFc2MnVWNXFOSXQxU3dNWmRVOEFNckFIMC4iLCJzY3AiOiJhY2Nlc3NtbV9hc191c2VyIGFwaWV4cG9zZXMiLCJzdWIiOiJXby14d1gweFBXaG1XYmdjeDlFTW1Eamx6LUZOOTgxblBxLTdDLW9jTmgwIiwidGlkIjoiZDM5YjMwMTgtNjg4Zi00ZDBkLTlmY2UtOGMzY2IxMTY5YzIxIiwidXRpIjoibVRMd1JDZGJLMEdsZVVvNml1RXBBUSIsInZlciI6IjIuMCJ9.WR6mH8mAUbupoTlboBgHSKgwG9lU9rmMyO7MKK_PH49PraEHR2WCB8VWmJNe0WmkIyFCMH0w3aXCZYIf9_DiYcDB_vP5_xQ0edxlg7_u2E6a3ZOV1R5hERJATsiZqrirCPWkUFC-tCcYsR4lqmgBoXv3KWaawKbViMOL3a_kgBbFfs2UVzaOgZhSlD8UN-Yeh3CJ7DNCTUZnRc6lUPLyuZL0Yest7PUJTDwCNwr5exSIr4uVD1ne-CFSk3ejN-cwQUf2pJRg1bm2fl1C3fhcXZ2M2gEBpqDPQOnPUNC-DBlasbqy7_XAMBVqU5vksnxDp7SYBCQSTfkQqaGKn4i2Ew";
  // console.log("#############1");
  if (accessToken != null) {
    // console.log("#############2");
    config.headers = {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: `Bearer ${accessToken}`,
    };
  }
  config.timeout = 50000;
  config.baseURL = process.env.VUE_APP_API;
  return config;
});

axios.interceptors.response.use(
  async (resp) => {
    // count401 = 0;

    // let authService = new AuthService();
    // console.log("call authService", await authService.getAccessToken());

    // console.log("Response");
    // console.log(resp);
    return resp;
  },
  async (error) => {
    try {
      const originalRequest = error.config;
      const {
        response: { status },
      } = error;
      if (status === 401 && !originalRequest._retry) {
        console.log(status);

        // console.log("Count 401", count401);

        // window.location = "/logout";
        // Try to request token
        /* if (count401 < 3) {
          count401 += 1; */

        let authService = new AuthService();
        await authService.getAccessToken();

        return axios(originalRequest);
        // }
      }
    } catch (e) {
      if (String(error).includes("timeout of 1000ms") === true) {
        return { status: 0, message: "The Server connection time out." };
      } else {
        return { status: 0, message: error };
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
